var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFineTuneImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.987,
    height: 484.11,
    viewBox: "0 0 799.987 484.11",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-667.431 -409.309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M674.49,553.994v10.488l-16.21-.953.226-8.638Z",
    transform: "translate(255.02 219.218)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.85,728.695c-.954,5.721.954,5.721-14.3,7.628S883.1,725.834,883.1,725.834a80.124,80.124,0,0,1,3.814-17.163c2.861-7.628,18.117,1.907,18.117,1.907S909.8,722.974,908.85,728.695Z",
    transform: "translate(25.428 73.123)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.28,553.994v10.488l16.209-.953-.226-8.638Z",
    transform: "translate(177.135 218.598)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.806,728.695c.953,5.721-.954,5.721,14.3,7.628s11.442-10.488,11.442-10.488a80.134,80.134,0,0,0-3.814-17.163c-2.86-7.628-18.116,1.907-18.116,1.907S881.853,722.974,882.806,728.695Z",
    transform: "translate(-52.159 72.503)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.479,0H0V14.605H29.3Z",
    transform: "translate(1246.539 537.065)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1234.452 850.894)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.667,
    height: 26.484,
    transform: "translate(36.399)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.74,592.216c8.193,0,20.155-.856,20.245-.865,3.2.285,19.175,1.542,19.969-2.113a15.7,15.7,0,0,0-.5-7.35c-1.542-15.27-2.113-15.448-2.452-15.547-.543-.16-2.13.6-4.707,2.255l-.16.106-.035.188c-.045.232-1.181,5.839-6.6,4.988-3.708-.588-4.911-1.408-5.295-1.81a2.281,2.281,0,0,0,.98-.82,2.868,2.868,0,0,0,.2-2.389,37.791,37.791,0,0,0-2.871-6.445l-.24-.428L502.068,576.3l-13.1,3.745a3.354,3.354,0,0,0-2.184,1.935h0a3.38,3.38,0,0,0,.856,3.816c2.38,2.139,7.114,5.8,12.075,6.258,1.319.131,3.066.169,5.028.169h0Z",
    transform: "translate(-486.517 -549.701)",
    fill: "#2f2e43"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1182.535 850.894)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.667,
    height: 26.484,
    transform: "translate(36.399)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.74,592.216c8.193,0,20.155-.856,20.245-.865,3.2.285,19.175,1.542,19.969-2.113a15.7,15.7,0,0,0-.5-7.35c-1.542-15.27-2.113-15.448-2.452-15.547-.543-.16-2.13.6-4.707,2.255l-.16.106-.035.188c-.045.232-1.181,5.839-6.6,4.988-3.708-.588-4.911-1.408-5.295-1.81a2.281,2.281,0,0,0,.98-.82,2.868,2.868,0,0,0,.2-2.389,37.791,37.791,0,0,0-2.871-6.445l-.24-.428L502.068,576.3l-13.1,3.745a3.354,3.354,0,0,0-2.184,1.935h0a3.38,3.38,0,0,0,.856,3.816c2.38,2.139,7.114,5.8,12.075,6.258,1.319.131,3.066.169,5.028.169h0Z",
    transform: "translate(-486.517 -549.701)",
    fill: "#2f2e43"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.834,
    cy: 35.194,
    rx: 150.834,
    ry: 35.194,
    transform: "translate(884.19 809.025)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.728,600.948H150.509V585.1c16.5-11.483,31.121-10.485,50.354.933Z",
    transform: "translate(711.62 -97.46)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.567,766.314a4.216,4.216,0,0,1-4.1-3.285L194.135,639.441a1.359,1.359,0,0,0-1.365-1.095h-.007a1.359,1.359,0,0,0-1.362,1.108L165.381,762.21a4.216,4.216,0,0,1-4.105,3.326h-12.4a4.2,4.2,0,0,1-4.189-4.444L153.924,605.5l3.715-1.1h.07l72.973.638,15.542,155.417a4.194,4.194,0,0,1-3.838,4.589L226.9,766.3Q226.734,766.315,226.567,766.314Z",
    transform: "translate(688.161 13.087)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.378.456l20.3-1.187,2,15.792H0Z",
    transform: "translate(872.257 471.741)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.807,730.926a39.525,39.525,0,0,1-11.868-1.67,26.2,26.2,0,0,1-15.888-13.4,4.2,4.2,0,0,1-.312-3.127c2.526-8.621,14.732-53.431,6.944-89.054a37.751,37.751,0,0,1,5.367-29.013A37.278,37.278,0,0,1,183.225,578.4h0c1.292-.252,2.59-.459,3.86-.615a37.143,37.143,0,0,1,30.08,9.9,38.064,38.064,0,0,1,11.95,30.175L223.13,713.9a4.158,4.158,0,0,1-2.236,3.453C214,720.965,193.293,730.926,174.807,730.926Z",
    transform: "translate(695.757 -95.276)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.054,722.722a4.2,4.2,0,0,1-1.68-.355L144.92,703.4a4.168,4.168,0,0,1-2.381-4.921l28.767-108.669a15.727,15.727,0,0,1,19.527-11.1l11.5,3.283-8.1,136.775a4.208,4.208,0,0,1-2,3.328,4.162,4.162,0,0,1-2.182.624Z",
    transform: "translate(678.934 -92.839)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.767,698.481l-1.912-7.208-2.769-10.481-1.334-5.026-2.769-10.453L187,589.812a15.71,15.71,0,0,0-19.526-11.1L155.977,582l5.7,96.2.588,10.043.373,6.331v.009l.6,9.987.84,14.2a4.187,4.187,0,0,0,5.865,3.6L213.389,703.4a4.164,4.164,0,0,0,2.378-4.923Z",
    transform: "translate(733.643 -92.842)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.903,
    cy: 22.902,
    rx: 22.903,
    ry: 22.902,
    transform: "translate(861.693 429.272)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.088,381.717,81.6,394.191l-.588-10.041,45.31-12.891Z",
    transform: "translate(814.304 201.211)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.421,384.821,81.8,398.119l-.6-9.99v-.01l48.453-13.781Z",
    transform: "translate(815.072 213.614)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.89,582.371a28.12,28.12,0,0,0-30.821-17.329l7.221,5.835c-8.972.3-18.416-.34-24.822,5.949,2.039-.056,4.712,4.305,6.752,4.249a10.7,10.7,0,0,0-8.954,6.176,17.592,17.592,0,0,0-1.039,11.187,130,130,0,0,0,8.044,15.982c-.266-9.11,17.67-30.841,26.428-28.572a24.035,24.035,0,0,0-11.1,8.425,32.55,32.55,0,0,1,19.3-3.158,13.658,13.658,0,0,0,4.6.257,5.618,5.618,0,0,0,3.331-8.979Z",
    transform: "translate(708.576 -147.055)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.748,385.736l-.588,9.854L67.582,381.719l2.73-10.317Z",
    transform: "translate(760.232 201.788)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.036,389.793l-47.528-15.34L66.773,384.8l49.685,14.8Z",
    transform: "translate(756.973 214.077)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.741,673.721a10.017,10.017,0,0,0,6.568-13.885l22.344-70.145-15.844-3.318-20.485,68.772a10.071,10.071,0,0,0,7.418,18.576Z",
    transform: "translate(673.569 -59.545)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.028,580.173h0c4.55.464,7.109,5.58,5.977,11.949l-5.428,30.565c-.407,2.291-2.293,4.105-3.86,3.714l-18.361-4.589c-1.413-.353-1.933-2.361-1.133-4.369l11.023-27.651A13.306,13.306,0,0,1,168.028,580.173Z",
    transform: "translate(688.816 -84.513)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.1,633.752a9.826,9.826,0,0,1,1.517.3l35.1-30.1L197.672,592.9l16.265-5.275,5.533,19.2a7.46,7.46,0,0,1-3.179,8.37l-44.458,28.133a9.788,9.788,0,1,1-8.729-9.575Z",
    transform: "translate(718.665 -54.5)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.073,580.9h0c4.86-1.36,9.716,2.339,11.343,8.64l7.808,30.24c.585,2.267-.552,4.676-2.327,4.931L164.1,627.7c-1.6.23-3.011-1.411-3.069-3.573l-.808-29.758a13.09,13.09,0,0,1,7.854-13.473Z",
    transform: "translate(750.406 -82.716)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.773,743.487a12.036,12.036,0,0,1-2.311-18.309l-9.043-128.339,26.051,2.527.716,125.683a12.1,12.1,0,0,1-15.412,18.439Z",
    transform: "translate(1041.537 -17.387)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.806,647.92a5.02,5.02,0,0,1-2.082-3.81l-1.909-34.59a13.89,13.89,0,0,1,27.275-4.4l8.385,30.926a5.047,5.047,0,0,1-3.547,6.185L241.077,648.7a5.023,5.023,0,0,1-4.271-.778Z",
    transform: "translate(1043.047 -25.344)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.865,563h0a29.832,29.832,0,0,1,29.815,28.9l5.619,0a1.865,1.865,0,0,1,1.865,1.865v7.46a1.865,1.865,0,0,1-1.865,1.865H150.89a1.865,1.865,0,0,1-1.865-1.865v-8.392A29.839,29.839,0,0,1,178.865,563Z",
    transform: "translate(705.644 -153.689)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.988,783.287l-15.12-.721a5.039,5.039,0,0,1-4.8-5c-3.986-61.526-9.507-127.5-1.055-152.985a5.042,5.042,0,0,1,5.766-5.025l60.489,8.781a5.012,5.012,0,0,1,4.317,4.951c7.723,30.177,8.072,84.9,7.78,141.757a5.042,5.042,0,0,1-5.041,5.08h-16.3a5.018,5.018,0,0,1-4.98-4.258l-10.532-80.044a3.921,3.921,0,0,0-7.767.144l-7.509,82.884a5.061,5.061,0,0,1-5.006,4.443Q245.108,783.294,244.988,783.287Z",
    transform: "translate(989.815 73.906)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.41,746.846a76.1,76.1,0,0,0-28.769-9.854,4.949,4.949,0,0,1-3.421-1.875,5.016,5.016,0,0,1-1.043-3.81L234.671,623.7a37.216,37.216,0,0,1,21.693-29.08,36.193,36.193,0,0,1,35.173,2.757q.745.5,1.462,1.012a37.169,37.169,0,0,1,14.157,38.733c-8.888,36.359-11.941,95.968-12.463,107.548a5,5,0,0,1-3.269,4.487,50.506,50.506,0,0,1-17.058,3.037A42.714,42.714,0,0,1,253.41,746.846Z",
    transform: "translate(992.039 -39.644)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.516,
    cy: 27.516,
    rx: 27.516,
    ry: 27.516,
    transform: "translate(1230.056 485.338)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.022,637.119a8.888,8.888,0,0,1-15.335-4.937,9,9,0,0,1,.011-1.743,40.4,40.4,0,0,0,1.8-9.807,5.143,5.143,0,0,0-.941-2.407c-4.091-5.478-13.693,2.45-17.553-2.509-2.367-3.04.415-7.828-1.4-11.226-2.4-4.485-9.5-2.273-13.952-4.729-4.955-2.733-4.659-10.335-1.4-14.959a23.53,23.53,0,0,1,17.839-9.082,47.854,47.854,0,0,1,20.157,3.933A40.283,40.283,0,0,1,282.3,592.86a32.24,32.24,0,0,1,3.259,27.45A51.743,51.743,0,0,1,274.022,637.119Z",
    transform: "translate(1003.02 -102.5)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.595,603.368c-.482-2.263-4.616-5.355-10.531-7.876a65.13,65.13,0,0,0-58.816,5.041,2.778,2.778,0,0,0-2.566,2.185l-19.9,88L223.2,702.179l-1.714,7.585L218.9,721.191l-1.378,6.106A2.81,2.81,0,0,0,220,730.714l85.916,7.416c.078,0,.168.011.246.011a2.8,2.8,0,0,0,2.778-2.621l.818-12.447.874-13.309.381-5.77.863-13.276,5.725-87.2v-.078Z",
    transform: "translate(981.237 -41.997)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.919,601.613a11.766,11.766,0,0,1,.268,1.838l48.126,27.763,11.7-6.734L300.48,640.8l-25.025,17.836-54.9-43.314a11.758,11.758,0,1,1,7.367-13.714Z",
    transform: "translate(929.94 -34.702)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.318,625.927a5.021,5.021,0,0,1,1.449-4.093l24.494-24.5a13.89,13.89,0,0,1,21.474,17.383L249.292,641.6a5.047,5.047,0,0,1-6.973,1.484l-20.731-13.453a5.022,5.022,0,0,1-2.27-3.7Z",
    transform: "translate(988.653 -31.778)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.174,386.425l-.86,13.278-87.825-1.815,2.589-11.463Z",
    transform: "translate(1061.939 262.296)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.376,390.213l-.875,13.308-90.867-1.88,2.589-11.428Z",
    transform: "translate(1058.497 277.554)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.167,572.959h0a35.842,35.842,0,0,0-35.821,34.726l-6.751,0a2.241,2.241,0,0,0-2.24,2.241v8.962a2.241,2.241,0,0,0,2.24,2.241h76.181a2.24,2.24,0,0,0,2.241-2.24V608.809a35.85,35.85,0,0,0-35.85-35.85Z",
    transform: "translate(992.943 -113.569)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.94,713.962h-7.684c-.049-.93-10.365-25.139-10.365-25.139l-6.236-15.083-4.122-10.056L313.3,648.6l-7.139-17.346a3.562,3.562,0,0,0-6.938,0L292.082,648.6l-6.236,15.083-4.122,10.056-6.236,15.083s-10.316,24.208-10.365,25.139h-7.684a7.542,7.542,0,1,0,0,15.083h90.5a7.542,7.542,0,1,0,0-15.083Z",
    transform: "translate(1111.937 110.147)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.631,423.392H180.945l6.234-15.083H208.4Z",
    transform: "translate(1216.833 350.44)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.286,428.392h-54.4l6.234-15.083h41.932Z",
    transform: "translate(1208.536 370.579)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(667.431 767.724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355,760.111h-2.978c.273-.643-12.96-34.49-12.96-34.49l-7.944-19.357-5.33-12.972-7.944-19.357-8.646-20.966a4.557,4.557,0,0,0-8.85,0L291.7,673.935l-7.944,19.357-5.381,12.972-7.942,19.357s-13.183,33.848-12.911,34.49h-3.079a7.542,7.542,0,1,0,0,15.083H355a7.542,7.542,0,1,0,0-15.083Z",
    transform: "translate(-246.898 -649.5)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.157,449.526H178.125l7.944-19.357h26.144Z",
    transform: "translate(-141.275 -405.732)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.1,455.956H175.475l7.944-19.357H236.16Z",
    transform: "translate(-151.949 -379.834)",
    fill: "#f2f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFineTuneImage);
export default __webpack_public_path__ + "static/media/fine_tune_image.56a6c53ca5328e52e8e38fc24d9d4228.svg";
export { ForwardRef as ReactComponent };